module.exports = __webpack_public_path__ + "fe4f01ad8e120fb59dd8853931f39e9e.svg";